import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import { format } from "date-fns";

export default {
  name: "workOrders",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage:
        "Loading work orders...Dragging them in from the database...",
      sortBy: "name",
      filter: "",
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "client_name", label: "Client", sortable: true },
        { key: "field_name_with_cutting", label: "Field", sortable: true },
        { key: "commodity", label: "Commodity", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    workOrders: function() {
      return this.$store.getters.workOrdersForTable;
    },
  },
  created() {
    const jsConn = new JSConn();
    jsConn.formParams = {
      statuses: ["pending", "queued", "completed"],
    };
    this.$store.dispatch("needWorkOrders", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
  methods: {
    queueWorkOrder(id) {
      const jsConn = new JSConn();
      const jsConnWorkOrders = new JSConn();

      const td = format(new Date(), "yyyy-MM-dd");
      jsConn.formParams = {
        id: id,
        start_date: td,
      };
      this.$store.dispatch("queueWorkOrder", jsConn).then(() => {
        // load all the work orders again
        // very likely a more efficient way to do this
        // but this is the least amount of code and the quickest at this time
        // 2019-03-27
        return this.$store.dispatch("needWorkOrders", jsConnWorkOrders);
      });
    },
    getWorkOrdersByStatus(status) {
      this.dataLoaded = false;
      const jsConn = new JSConn();
      jsConn.formParams = {
        statuses: [status],
      };
      this.$store.dispatch("needWorkOrders", jsConn).then(() => {
        this.dataLoaded = true;
      });
    },
  },
};
